var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{staticClass:"contests-plot",attrs:{"type":"rangeBar","height":"200","options":_vm.chartOptions,"series":_vm.plotSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }